"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConcernFormAction = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _concernFormContext = require("../../../contexts/concernFormContext");
var _utils = require("../../../utils");
var _scrollToPosition = require("../../../utils/scrollToPosition");
const useConcernFormAction = ()=>{
    const globalApiClient = (0, _globalApiClientReact.useApiClient)();
    const { concernFormData, setSentValues, setIsFormSent, setIsServerError, setEditable } = (0, _concernFormContext.useConcernForm)();
    const onSubmitHandler = (0, _react.useCallback)(async (formValues)=>{
        const payload = {
            dataCollection: (0, _utils.mapAnswersToDataCollection)({
                questions: concernFormData.questions,
                formValues
            }),
            reCaptchaToken: formValues.recaptcha
        };
        const { status } = await (0, _globalApiClientReact.createApplicationsConcernReportForm)(globalApiClient, payload);
        if (status === 204) {
            (0, _scrollToPosition.scrollToPosition)(0);
            setSentValues(formValues);
            setEditable(false);
        }
        setIsServerError(status !== 204);
        setIsFormSent(true);
    }, [
        concernFormData.questions,
        globalApiClient,
        setEditable,
        setIsFormSent,
        setIsServerError,
        setSentValues
    ]);
    return {
        onSubmitHandler
    };
};
exports.useConcernFormAction = useConcernFormAction;
